export const iconFontAwesomeConstructionScrewdriver = (
	<i className="fa-solid fa-screwdriver"></i>
);
